import { IFormState, IRootReducerState } from "./rootReducer";
import { ICataloguedItems } from "../types/wizard-types";
import {
  IScheduledServiceDisable,
  IServiceDisableMetadata,
  ServiceType,
} from "../types/audit";

export const selectForm = (state: IRootReducerState): IFormState =>
  state.form as any;
export const selectToken = (state: IRootReducerState): string =>
  state.authReducer.token;
export const selectAddMore = (state: IRootReducerState): boolean =>
  state.addMoreReducer.addMore;
export const selectCats = (state: IRootReducerState): ICataloguedItems[] =>
  state.menuReducer.categories;
export const selectMenus = (state: IRootReducerState): string[] =>
  state.orderingMenusReducer.menus;
export const selectShownGiftListByPosId = (state: IRootReducerState) =>
  state.multiPosGiftListReducer.shownGiftListByPosId;

export const selectGiftGroupsByPosId = (state: IRootReducerState) =>
  state.multiPosGiftGroupsReducer.giftGroupsByPosId;
export const selectShownGiftGroupsById = (state: IRootReducerState) =>
  state.giftGroupsReducer.shownGiftGroupsById;

export const selectStore = (state: IRootReducerState) => state.storeReducer.store;
export const selectAccountManager = (state: IRootReducerState) => state.storeReducer.accountManager;

export const selectStoreWorkingHours = (state: IRootReducerState) => state.getStoreWorkingHoursReducer;
export const selectPreviousBranchesWorkingHours = (state: IRootReducerState) => state.branchesWorkingHoursReducer.previousBranchesWorkingHours;
export const selectBranches = (state: IRootReducerState) => state.branchesReducer.allBranches;

export const selectServiceAuditState = (state: IRootReducerState) =>
  state.serviceAuditReducer;

export const selectScheduledDisable = (
  state: IRootReducerState,
  branchId: string,
  serviceType: ServiceType
): IScheduledServiceDisable | undefined =>
  state.serviceAuditReducer.scheduledDisables.find(
    (item) => item.branchId === branchId && item.serviceType === serviceType
  );

export const selectDisableMetadata = (
  state: IRootReducerState,
  branchId: string,
  serviceType: ServiceType
): IServiceDisableMetadata | undefined =>
  state.serviceAuditReducer.disableMetadata[branchId]?.[serviceType];